import * as Yup from "yup";

export const userRegistrationValidationSchema = Yup.object({
  firstName: Yup.string()
    .required("Full Name is required"),

  lastName: Yup.string()
    .required("Last Name is required"),

  companyName: Yup.string()
    .required("Company Name is required"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character"
    ),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Confirm Password is required"),

  telephoneNumber: Yup.string()
    .required("Telephone Number is required"),

  countryCode: Yup.string()
    .required("Country code is required"),
});
